import React from 'react';
import HeroSection from '../Components/HeroSection';

const About = () => {
    return (
        <div className='About'>
            <HeroSection name={"ElecDroid E-commerce Store"} />
        </div>
    )
}

export default About;